import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import GiveBack from "@/pages/GiveBack";
import CantHaul from "@/pages/CantHaul";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ServicesHub from "@/pages/ServicesHub";
import ServicePage from "@/pages/ServicePage";
import ServiceAreasHub from "@/pages/ServiceAreasHub";
import CityPage from "@/pages/CityPage";
import NeighborhoodPage from "@/pages/NeighborhoodPage";
import NotFound from "@/pages/NotFound";
import Gallery from "@/pages/Gallery";
import QuotePublic from "@/pages/QuotePublic";
import InvoicePublic from "@/pages/InvoicePublic";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

const page = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" />
        <Routes>
          <Route path="/" element={page(<Home />)} />
          <Route path="/about" element={page(<About />)} />
          <Route path="/gallery" element={page(<Gallery />)} />
          <Route path="/faq" element={page(<Faq />)} />
          <Route path="/contact" element={page(<Contact />)} />
          <Route path="/give-back" element={page(<GiveBack />)} />
          <Route path="/what-we-cant-haul" element={page(<CantHaul />)} />
          <Route path="/privacy" element={page(<Privacy />)} />
          <Route path="/terms" element={page(<Terms />)} />
          <Route path="/services" element={page(<ServicesHub />)} />
          <Route path="/services/junk-removal/:spoke" element={page(<ServicePage />)} />
          <Route path="/services/:slug" element={page(<ServicePage />)} />
          <Route path="/service-areas" element={page(<ServiceAreasHub />)} />
          <Route path="/service-areas/:slug/:hood" element={page(<NeighborhoodPage />)} />
          <Route path="/service-areas/:slug" element={page(<CityPage />)} />
          {/* Standalone (no marketing chrome) */}
          <Route path="/quote/:id" element={<QuotePublic />} />
          <Route path="/invoice/:id" element={<InvoicePublic />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={page(<NotFound />)} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
